import { Ban, CheckCircle2 } from "lucide-react";

export default function NoBrokerBanner() {
  return (
    <div className="bg-gradient-to-r from-[#FF7A00] to-[#FF9A2E] text-white" data-testid="no-broker-banner">
      <div className="max-w-7xl mx-auto px-4 py-3 md:py-4 text-center">
        <p className="font-display font-extrabold text-base md:text-2xl flex items-center justify-center gap-2 flex-wrap">
          <Ban className="w-5 h-5 md:w-6 md:h-6" /> नो ब्रोकर - नो दलाल - नो कमिशन <Ban className="w-5 h-5 md:w-6 md:h-6" />
        </p>
        <p className="mt-0.5 font-semibold text-sm md:text-lg flex items-center justify-center gap-1.5">
          <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 shrink-0" /> डायरेक्ट विक्रेता ते खरेदीदार - थेट संपर्क!
        </p>
        <p className="text-xs md:text-sm text-white/90">आपला व्यवहार, आपला फायदा - मध्ये कोणी नाही!</p>
        <p className="mt-1 inline-block rounded-full bg-white text-green-700 font-bold text-xs md:text-sm px-3 py-0.5" data-testid="banner-property-line">नो ब्रोकर - नो दलाल - प्रॉपर्टी डायरेक्ट मालकाकडून</p>
      </div>
    </div>
  );
}
